module.exports = __webpack_public_path__ + "static/media/USGS_logo_green.67ec804c.svg";